RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    apps.Site = window.createMarionetteApp();
    apps.Site.name = 'Site';

});
